import { render } from "./Contact.vue?vue&type=template&id=7f955a69&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=7f955a69&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f955a69"

export default script